import React from "react";
import NavBar from "../components/partials/NavBar";
import HeroSection from "../components/homepage/HeroSection";
import About from "../components/homepage/About";
import MintingSection from "../components/homepage/MintSection";
import Lore from "../components/homepage/Lore";
import RoadMap from "../components/homepage/RoadMap";
import RoadMapV2 from "../components/homepage/RoadMapV2";
import Faq from "../components/homepage/Faq";
import Team from "../components/homepage/Team";
import Footer from "../components/partials/Footer";
import classes from "./Homepage.module.css";
import * as anchor from "@project-serum/anchor";
import { useMemo } from "react";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSlopeWallet,
  getSolflareWallet,
  getSolletWallet,
  getSolletExtensionWallet,
} from "@solana/wallet-adapter-wallets";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

export interface HomeProps {
  candyMachineId?: anchor.web3.PublicKey;
  connection: anchor.web3.Connection;
  startDate: number;
  txTimeout: number;
  rpcHost: string;
}

const Homepage = (props: HomeProps) => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);
  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSlopeWallet(),
      getSolflareWallet(),
      getSolletWallet({ network }),
      getSolletExtensionWallet({ network }),
    ],
    []
  );

  return (
    <ThemeProvider theme={theme}>
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect={true}>
          <WalletDialogProvider>
            <div>
              <NavBar
                candyMachineId={props.candyMachineId}
                connection={props.connection}
                startDate={props.startDate}
                txTimeout={props.txTimeout}
                rpcHost={props.rpcHost}
              />
              <div className={classes["app-inner-wrapper"]}>
                <HeroSection />
                <About />
                <MintingSection
                  candyMachineId={props.candyMachineId}
                  connection={props.connection}
                  startDate={props.startDate}
                  txTimeout={props.txTimeout}
                  rpcHost={props.rpcHost}
                />
                <Lore />
                <RoadMap />
                {/* <RoadMapV2 /> */}
                <Faq />
                <Team />
              </div>
              <Footer />
            </div>
          </WalletDialogProvider>
        </WalletProvider>
      </ConnectionProvider>
    </ThemeProvider>
  );
};

export default Homepage;
